import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import VyModal from '../../../../../../common/VyModal';
import PresentationsSettings from './PresentationsSettings';
import PresentationsSlots from './PresentationsSlots';

const PBPresentationsModal = ({ onClose }: { onClose: () => void }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [actions, setActions] = useState<JSX.Element[]>([]);

  const { t } = useTranslation();

  return (
    <>
      <VyModal open={true} maxWidth={'100cqw'} onClose={onClose} hasDefaultPadding={false}>
        {(onClose) => (
          <div className="flex flex-col w-full modal" style={{ height: '70vh' }}>
            <div className="w-full flex flex-row justify-between  shadow-md sticky top-0 z-20 bg-white">
              <Tabs value={currentTab} onChange={(undefined, tab) => setCurrentTab(tab)} indicatorColor="primary" textColor="primary" centered>
                <Tab label={t('account:presentation-slots')} />
                <Tab label={t('account:settings')} />
              </Tabs>
              <div className="flex flex-col md:flex-row space-x-2 items-center p-2">{actions.map((a) => a)}</div>
            </div>

            <div className="p-2">
              {currentTab === 0 && <PresentationsSlots setActions={setActions} />}
              {currentTab === 1 && <PresentationsSettings setActions={setActions} />}
            </div>
          </div>
        )}
      </VyModal>
      <style>
        {`
          @media screen and (min-width: 864px) {
            .modal {
              width: 70vw; 
            }
          }
          
          @media screen and (max-width: 864px) {
            .modal {
              width: 100vw; 
            }
          }
        `}
      </style>
    </>
  );
};
export default PBPresentationsModal;
